<div class="row">
    <div class="col-4 col-md-2 text-center my-3 cursor-po" [ngClass]="{'col-6 col-md-3': posterType == 'h'}"
        *ngFor="let asset of assets">
        <app-asset-card [asset]="asset" [style]="posterType == 'h' ? 'B' : 'C'"></app-asset-card>
    </div>
</div>